import { takeLatest } from 'redux-saga';
import { put, call, fork, select } from 'redux-saga/effects';

import { BRIEF } from '../../utils/static-configuration';
import { SEND_BRIEF_ALL } from './constants';
import { getUserId } from '../../selectors/user-selectors';
import { getCampaignId, getPermissionId } from '../../selectors/campaign-selectors';
import { sendbirdSendBriefAll } from '../../utils/sendbird-send-all-service';
import { MODAL_LOADING, MODAL_ERROR, MODAL_CLEAR } from '../../constants/modal';
import { RELOAD_DISCUSSIONS } from '../../containers/discussion-list/constants';
import { reportError } from '../../utils/error-handling-service';

export function* sendBriefAll(action) {
  try {

    yield put({ type: MODAL_LOADING, loading: true });

    const { documentData } = action.data;
    documentData.docType = BRIEF;

    const userId = yield select(getUserId);
    const campaignId = yield select(getCampaignId);
    const permissionId = yield select(getPermissionId);

    const data = {
      userId,
      campaignId,
      permissionId,
      message: documentData.message,
      documentData,
    };

    const response = yield call(sendbirdSendBriefAll, data);

    yield put({ type: RELOAD_DISCUSSIONS, data: { campaignId } });
    yield put({ type: MODAL_CLEAR });

  } catch (error) {
    reportError('SEND_BRIEF_ALL_ERROR', error.message);
    yield put({ type: MODAL_ERROR, error: error.message });
  }
}

export function* watchSendBriefAll() {
  yield takeLatest(SEND_BRIEF_ALL, sendBriefAll);
}

export default function* sendBriefAllSagas() {
  yield [
    fork(watchSendBriefAll)
  ];
}



/** WEBPACK FOOTER **
 ** ./src/containers/send-brief-all-modal/sagas.js
 **/